import { Component } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { FaIconComponent } from '@fortawesome/angular-fontawesome'
import { WjInputModule } from '@grapecity/wijmo.angular2.input'
import { DataMap } from '@grapecity/wijmo.grid'

import { ListItem, ProposalBidDetail, RepositoryModal } from '../../shared'

@Component({
    templateUrl: './proposal-bid-detail.component.html',
    standalone: true,
    imports: [FormsModule, WjInputModule, FaIconComponent],
})
export class ProposalBidDetailComponent extends RepositoryModal<ProposalBidDetail> {
    competitorsList: ListItem<number>[] = []

    protected onInitialized() {
        const competitorsMap = this.editOptions.initializeParams.competitorsMap as DataMap
        if (competitorsMap) {
            this.competitorsList = competitorsMap.collectionView.items.map(i => new ListItem(i.id, i.name))
        }
    }

    onBeforeSave() {
        if (this.isAdding) {
            this.target.proposalBidId = this.editOptions.initializeParams.grid.selectedItem.id
        }
        return true
    }
}
